import { indexes } from '@mab-common/utils'

import type { ArtistProfileListProps } from '../ArtistProfileList/ArtistProfileList'
import ArtistProfileList from '../ArtistProfileList/ArtistProfileList'

import RecordTypes = indexes.RecordTypes

import { useRouter } from 'next/router'

import Fixture from '~/components/atoms/Fixture/Fixture'
import { TextSizes } from '~/components/atoms/Text/Text'
import VerticalPadder from '~/components/atoms/VerticalPadder/VerticalPadder'
import type { ComponentTheme } from '~/components/themes'
import { useSettingsContext } from '~/contexts/settingsContext'
import {
  SearchAnalystEventNames,
  SearchAnalystMethods,
} from '~/services/elastic/analyst'

export interface RelatedArtistArticlesProps {
  artists: ArtistProfileListProps['artists']
  countType: ArtistProfileListProps['countType']
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  theme?: ComponentTheme
  title?: string
  testID?: string
  moduleId?: string
  showViewAll?: boolean
}

export default function FeaturedArtistsModule({
  verticalPadding,
  noPaddingBottom = false,
  theme,
  testID,
  title,
  moduleId,
}: RelatedArtistArticlesProps) {
  const router = useRouter()

  const { featuredArtists, totalArtists } = useSettingsContext()

  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <VerticalPadder noPaddingBottom={true}>
        <ArtistProfileList
          artists={featuredArtists ? featuredArtists : []}
          totalArtists={totalArtists ? totalArtists : 0}
          totalArtistsTitle="Other notable artists"
          allBtnHandler={() => router.push('/artists')}
          titleSize={TextSizes.primaryTitleMed}
          title={title}
          recordType={RecordTypes.ARTIST}
          searchInsightsEvent={{
            method: SearchAnalystMethods.clickedFilters,
            name: SearchAnalystEventNames.artworksArtistClicked,
          }}
          ariaControlId="artist-list"
          showViewAll={true}
        />
      </VerticalPadder>
    </Fixture>
  )
}
